import { render, staticRenderFns } from "./SettingsMachine.vue?vue&type=template&id=22900553"
import script from "@/scripts/modal/rentalService/settingsMachine.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/rentalService/settingsMachine.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports